/* eslint-disable indent */
/* eslint-disable @typescript-eslint/indent */
import { Crate } from '@piwikpro/platform';
import HttpCrate from '@piwikpro/http-crate';
import NotificationCrate from '@piwikpro/notification-crate';
import { TrafficMonitor } from './TrafficMonitor';
import trafficMonitor from './redux';

@Crate({
  name: 'TrafficMonitorCrate',
  imports: [
    HttpCrate,
    NotificationCrate,
  ],
  services: [
    { name: 'trafficMonitor', provide: TrafficMonitor },
  ],
  reducers: {
    trafficMonitor,
  },
})
export class TrafficMonitorCrate {}
